module.exports = __webpack_public_path__ + "img/selected1-min.ce3862e4.png";